<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>业务办理</a-breadcrumb-item>
				<a-breadcrumb-item>设备操控</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button icon="sync" @click="apiElevatorQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="条件查询">
				<div class="qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">电梯名称：</div>
						<a-input v-model="query.elevatorName" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
				</div>
				<div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center;">
					<a-button type="primary" icon="search" @click="apiElevatorQueryList">查询</a-button>
					<a-button icon="redo" @click="resetChange" style="margin-left: 14px;">重置</a-button>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="elevatorId" :loading="tableLoading" :pagination="false">
				<span slot="elevatorName" slot-scope="elevatorName">
					<a-button type="link" @click="edit(elevatorName)" >{{elevatorName.elevatorName}}</a-button>
				</span>
				<span slot="elevatorState" slot-scope="elevatorState">
					<a-tag v-if="elevatorState == 3" color="green">启用</a-tag>
					<a-tag v-if="elevatorState == 2" color="red">禁用</a-tag>
				</span>
				<span slot="lastTime" slot-scope="lastTime">
					<a-badge v-if="(moment(lastTime).valueOf() + 180000) > new Date().getTime()" status="processing" text="在线" />
					<a-badge v-if="(moment(lastTime).valueOf() + 180000) < new Date().getTime()" status="red" text="离线" />
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 修改弹窗 -->
		<a-modal title="电梯运行设置" width="60%" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="editVisible = false"  :maskClosable="false" :keyboard="false">
			<a-form-model style="" ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
				<a-form-model-item label="电梯名称" has-feedback prop="elevatorName">
					{{editForm.elevatorName}}
				</a-form-model-item>
				<a-form-model-item label="是否启用" has-feedback prop="elevatorState">
					<a-radio-group name="elevatorState" v-model="editForm.elevatorState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="楼层控制" has-feedback prop="staffAccount">
					<div style="display: flex;flex-wrap: wrap;">
						<div style="width: 200px;display: flex;align-items: center;" v-for="(item, index) in editForm.storeyMode" :key="index">
							<div style="width: 50px;">【{{index}}】</div>
							<a-switch checked-children="刷卡模式" un-checked-children="自由通行" :default-checked="item==3? true:false" @change="(e)=>modeChange(e, index)" />
						</div>
					</div>
					
				</a-form-model-item>
				
			</a-form-model>
		</a-modal>
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				allElevator: [
				],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					elevatorName: '',
				},
				tableData: [],
				tableColumns: [
					{ title:'ID', dataIndex:'elevatorId', key:'elevatorId', align:'center'},
					{ title:'电梯名称', key:'elevatorName', align:'center', scopedSlots:{customRender:'elevatorName'}},
					{ title:'楼层', dataIndex:'elevatorStorey', key:'elevatorStorey', align:'center'},
					{ title:'是否启用', dataIndex:'elevatorState', key:'elevatorState', align:'center', width: '80px', scopedSlots:{customRender:'elevatorState'}},
					{ title:'在线状态', dataIndex:'lastTime', key:'lastTime', align:'center', width: '80px', scopedSlots:{customRender:'lastTime'}},
					
				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				// 添加弹窗-start
				addRules: {
					elevatorName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
					elevatorState: [{ required: true, message: '请选择', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				
				editForm: {
					elevatorId: '',
					elevatorName: '',
					elevatorStorey: '',
					elevatorState: 3,
					elevatorMode: 2,
					storeyMode: {},
				},
				// 修改弹窗-end
			};
		},
		methods: {
			//重置
			resetChange() {
				this.query = {
					page: 1,
					size: 10,
					total: 0,
					elevatorName: '',
				}
			},
			//表格开始-搜索
			async apiElevatorQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiElevatorQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiElevatorQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiElevatorQueryList()
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				let items = JSON.parse(JSON.stringify(item))
				this.editForm = items
				this.editForm.elevatorStoreyList = this.editForm.elevatorStorey.split(",")
				this.editForm.storeyMode = JSON.parse(this.editForm.storeyMode)
				this.editVisible = true
				console.log(this.editForm);
			},
			async apiElevatorMode() {
				let items = JSON.parse(JSON.stringify(this.editForm))
				items.storeyMode = JSON.stringify(items.storeyMode)
				const {
					data: res
				} = await this.$http.post(this.navigation.apiElevatorMode, items);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiElevatorQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.apiElevatorMode()
				
			},
			//修改弹窗事件-结束
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.elevatorId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.elevatorName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiElevatorDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiElevatorDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiElevatorDel, {elevatorId: this.tableSelectedRows.elevatorId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiElevatorQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			tableEdit() {
				if(this.tableSelectedRows.elevatorId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
			modeChange(e, index) {
				let mode = 3
				if (e == false) mode = 2
				this.editForm.storeyMode[index] = mode
				console.log(this.editForm.storeyMode)
			}
			
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0];
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiElevatorQueryList()
		}
	};
</script>

<style scoped>
	/deep/.ant-badge-status-processing{
		
		background-color: #52c41a;
	}
	/deep/.ant-badge-status-processing::after{
		border: 1px solid #52c41a;
	}
	.ant-form-item .ant-switch{
		margin: 0;
	}
</style>
